<div class="main-content-wrapper">
  <!-- Categories and fav Categories navBar-->
  <div class="dept-navbar">
    <button class="nav-link d-flex align-items-center" [class.active]="isButtonActive"
            (click)="toggleButtons()">
      {{ 'Favorites' | translate }}
      <span id="favQty" class="ms-2">{{favQuantity}}</span>
    </button>
    <button class="nav-link " [class.active]="!isButtonActive"
            (click)="toggleButtons()">
      {{ 'All Sub-Category' | translate }}
    </button>
  </div>
  <!-- Categories and fav Categories Content-->
  <div class="dept-wrapper mt-3">
    <div class="row" *ngIf="!isButtonActive">
      <div class="col-xl-3 col-md-4 col-sm-6 position-relative" *ngFor="let item of subCategories; let i = index">
        <div class="dept-content" (click)="selectedCategory(item)">
          <div class="icon">
            <img class="img-fluid" [src]="item.imageIcon || 'assets/Pos-Catalog/akar-icons_image.svg'" (error)="item.imageIcon = 'assets/Pos-Catalog/akar-icons_image.svg'" />
          </div>
          <h6 (click)="selectedCategory(item)">
            {{ item.subCategoryName }}
          </h6>
        </div>
        <div class="favrIcon" style="text-align:end">
          <i class="fa-regular fa-star fa-xl" *ngIf="!item.favoriteId" (click)="fav(item)"></i>
          <i class="fa-solid fa-star fa-xl" style="color: #EDA519;" *ngIf="item.favoriteId" (click)="fav(item)"></i>
        </div>
      </div>
    </div>

    <!--Row for displaying fav items-->
    <div class="row" *ngIf="isButtonActive">
      <div class="col-xl-3 col-md-4 col-sm-6 position-relative" *ngFor="let favItem of combinedItemsList">
        <div class="dept-content" (click)="selectedCategory(favItem)">
          <div class="icon" (click)="selectedCategory(favItem)">
            <img class="img-fluid" [src]="favItem.imageIcon || 'assets/Pos-Catalog/akar-icons_image.svg'" (error)="favItem.imageIcon = 'assets/Pos-Catalog/akar-icons_image.svg'" />
          </div>
          <h6 (click)="selectedCategory(favItem)">
            <!-- {{ favItem.categoryId ? (favItem.departmentDescr  + ' / ' + favItem.categoryName ) : favItem.departmentDescr }}-->
            {{ favItem.subCategoryId ? (favItem.departmentDescr  + ' / ' + favItem.categoryName + ' / ' + favItem.subCategoryName) : favItem.departmentDescr }}
          </h6>
        </div>
        <div class="favrIcon" style="text-align:end">
          <i class="fa-solid fa-star fa-xl" style="color: #EDA519;" (click)="fav(favItem)"></i>
        </div>
      </div>
    </div>
  </div>
</div>
